import {
  FETCH_LAUNDRY_ALERTS,
  FETCH_LAUNDRY_ALERTS_UNREAD,
  READ_ALL_LAUNDRY_ALERTS,
  READ_LAUNDRY_ALERT,
  REMOVE_LAUNDRY_ALERT,
} from './LaundryAlertsActions'

const INITIAL_STATE = {
  unreadCount: 0,
  items: [],
  meta: {},
  filters: {},
}

const decrementIfUnread = (state, id) => {
  const item = state.items.find(i => i.id === id)
  if (!item || item.read) return state.unreadCount
  return Math.max(state.unreadCount - 1, 0)
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LAUNDRY_ALERTS_UNREAD.SUCCESS:
      return {
        ...state,
        unreadCount: action.payload.unread_count || 0,
      }
    case FETCH_LAUNDRY_ALERTS.SUCCESS: {
      const { data, filters } = action.payload
      const isNextPage = filters.page > 1

      // "Carregar mais" acumula; ignora ids repetidos entre páginas
      const items = isNextPage
        ? [
            ...state.items,
            ...data.data.filter(i => !state.items.some(s => s.id === i.id)),
          ]
        : data.data

      return {
        ...state,
        items,
        meta: data.meta,
        filters,
      }
    }
    case READ_LAUNDRY_ALERT.SUCCESS:
      return {
        ...state,
        unreadCount: decrementIfUnread(state, action.payload.id),
        items: state.items.map(i =>
          i.id === action.payload.id ? { ...i, read: true } : i
        ),
      }
    case REMOVE_LAUNDRY_ALERT:
      return {
        ...state,
        unreadCount: decrementIfUnread(state, action.payload.id),
        items: state.items.filter(i => i.id !== action.payload.id),
      }
    case READ_ALL_LAUNDRY_ALERTS.SUCCESS:
      return {
        ...state,
        unreadCount: 0,
        items: state.items.map(i => ({ ...i, read: true })),
      }
    default:
      return state
  }
}
